// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-page__img-container {
  max-width: 700px;
  padding-top: 20px;
  margin: 0 auto;
  width: 100%;
  overflow: hidden;
}
.not-found-page__img-container img {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/NotFoundPage/index.scss","webpack://./node_modules/@ergeon/core-components/src/components/variables.default.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,iBC6FK;ED5FL,cAAA;EACA,WAAA;EACA,gBAAA;AADF;AAEE;EACE,WAAA;AAAJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
